import Vue from 'vue'
import VueRouter from 'vue-router'
import { RouterList } from './router'
Vue.use(VueRouter)

const routes = RouterList;
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//绑定路由钩子处理路由事件
router.beforeEach((to, from, next) => {
  //非标签页子页面，正常导航
  if (!to.meta.tagsPath) {
    next()
  } else {
    //标签页子页面，导航到标签页
    const query = Object.assign({}, to.query);
    //标签子页面的地址作为参数传入标签页
    query.path = to.path;
    next({
      //导航到标签页
      path: to.meta.tagsPath,
      query
    })
  }
})
export default router
